import { request } from './client';
import type { LedgerEntry, LedgerSummary, ManualPaymentInput, MarkWinningsPaidInput } from '../types';

export const ledgerApi = {
  async getEntries(boardId: string): Promise<LedgerEntry[]> {
    return request<LedgerEntry[]>(`/api/squareup/boards/${boardId}/ledger`);
  },

  async getSummary(boardId: string): Promise<LedgerSummary> {
    return request<LedgerSummary>(`/api/squareup/boards/${boardId}/ledger?summary=true`);
  },

  async recordPayment(boardId: string, input: ManualPaymentInput): Promise<LedgerEntry> {
    return request<LedgerEntry>(`/api/squareup/boards/${boardId}/payments/manual`, {
      method: 'POST',
      body: input,
    });
  },

  async markWinningsPaid(boardId: string, input: MarkWinningsPaidInput): Promise<void> {
    return request<void>(`/api/squareup/boards/${boardId}/winnings-paid`, {
      method: 'PUT',
      body: input,
    });
  },
};
